import { Observable } from 'rxjs';

import { CatalogObject } from '@mirage-projects/cw-models';

/**
 * Abstract service definition to manage the catalogs endpoints
 */
export abstract class CatalogService {
    /**
     * Retrieves the information of the latest projects and sites opened
     * @param projectData Creation parameters
     */
    abstract getLatestDashboardElements(): Observable<CatalogObject[]>;

    /**
     * Retrieves a catalog object
     * @param catalogUrl catalog url to load
     */
    abstract getCatalogObject(catalogUrl: string): Observable<CatalogObject[]>;
}
